export default [
  { label: 'MTN', value: 'MTN' },
  { label: 'GLO', value: 'GLO' },
  { label: 'AIRTEL', value: 'AIRTEL' },
  { label: '9MOBILE', value: '9MOBILE' }
];
